// Redirections de l'admin : `null` laisse passer.
import { loginPath } from "@shared/client/session";
import type { SessionInfo } from "@shared/lib/auth-shared";

/** /admin/* : connecté avec un compte admin. Un compte sans droit voit la page de connexion, qui le lui dit. */
export function adminRule(session: SessionInfo | null, location: { pathname: string; search: string }) {
  return session?.isAdmin ? null : loginPath(location);
}
